import { withTranslation } from "next-i18next";
import { useCurrentUser } from "@hooks/use-current-user";
import Image from "@components/core/Image";
import DrawerClosetUnavailable from "./DrawerClosetUnavailable";

function DrawerClosetReturned({ t }) {
  const user = useCurrentUser();
  const subscriptionWithSuspensionWaiting = user?.subscription?.suspension_waiting;

  if (!subscriptionWithSuspensionWaiting) return <DrawerClosetUnavailable />;

  return (
    <div className="d-flex flex-column align-items-center bg-white py-4 px-3 text-center flex-grow-1">
      <h5 className="py-2 px-3 mb-0">{t('common:drawer.modal_closet_returned_with_subscription_suspension_waiting.your_return_is_confirmed')}</h5>
      <p className="mb-0 px-3 text-gray">{t('common:drawer.modal_closet_returned_with_subscription_suspension_waiting.unsubscribe_is_coming')}</p>
      <Image
        src="deliveryLightNeon"
        alt="skate"
        className="my-4"
        width={140}
      />
      <p className="pb-2 px-3 text-gray">{t('common:drawer.modal_closet_returned_with_subscription_suspension_waiting.come_back_anytime')}</p>
    </div>
  );
};

export default withTranslation("common")(DrawerClosetReturned);
